import { makeEnum } from '../util/mappingLib.js';

const PlaidLinkConfig = makeEnum({
  LIVE: 'live',
  MOCK: 'mock',
});

export { PlaidLinkConfig };
